import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { FaPhoneAlt } from 'react-icons/fa';
import IconComponent from '../IconComponent';

const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const toggleNavbar = () => {
    setIsNavOpen(!isNavOpen);
  };

  const closeNavbar = () => {
    setIsNavOpen(false);
  };

  return (
    <header>
      <nav className="navbar navbar-expand-lg navbar-light">
        <div className="container align-items-center justify-content-between">
          <Link
            to="/"
            className="navbar-brand d-flex align-items-center gap-2"
            onClick={closeNavbar}
          >
            <img
              src="/images/logo.jpg"
              alt="Huckleberry Logo"
              width="60"
              height="56"
              className="d-inline-block align-text-top"
            />
            <div className="d-flex flex-column lh-sm">
              <span className="fw-bold" style={{ fontSize: '1.25rem' }}>
                I'm Your Huckleberry
              </span>
              <span className="text-muted" style={{ fontSize: '1rem' }}>
                Professional Cleaning Services
              </span>
            </div>
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            aria-controls="navbarNav"
            aria-expanded={isNavOpen}
            aria-label="Toggle navigation"
            onClick={toggleNavbar}
          >
            {isNavOpen ? (
              <span style={{ fontSize: '1.5rem' }}>&times;</span>
            ) : (
              <span className="navbar-toggler-icon"></span>
            )}
          </button>

          <div className={`collapse navbar-collapse ${isNavOpen ? 'show' : ''}`} id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <NavLink className="nav-link" to="/" end onClick={closeNavbar}>
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/services" onClick={closeNavbar}>
                  Cleaning Services
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/about" onClick={closeNavbar}>
                  About Us
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/team" onClick={closeNavbar}>
                  Meet the Team
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/gallery" onClick={closeNavbar}>
                  Gallery
                </NavLink>
              </li>
            </ul>

            {/* Full-width Call Now button in the dropdown for mobile */}
            <a
              href="tel:7156518170"
              className="btn rounded-pill w-100 d-lg-none mt-3"
              style={{
                backgroundColor: '#3b5259',
                borderColor: '#3b5259',
                color: '#fff',
                whiteSpace: 'nowrap',
              }}
            >
              <IconComponent icon={FaPhoneAlt} />
              Call Now
            </a>
            {/* Auto-width inline Call Now button for desktop view */}
            <a
              href="tel:7156518170"
              className="btn rounded-pill ms-3 d-inline-flex align-items-center gap-2 d-none d-lg-inline-block"
              style={{
                backgroundColor: '#3b5259',
                borderColor: '#3b5259',
                color: '#fff',
                whiteSpace: 'nowrap',
              }}
            >
              <IconComponent icon={FaPhoneAlt} />
              Call 715-651-8170
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
